import { render, staticRenderFns } from "./OpenPayoffDownpaymentsView.vue?vue&type=template&id=2647d972&scoped=true&"
import script from "./OpenPayoffDownpaymentsView.vue?vue&type=script&lang=ts&"
export * from "./OpenPayoffDownpaymentsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2647d972",
  null
  
)

export default component.exports